export const changeDaysjsFormat = (DateToChange) => {
  var formatedDate =
    DateToChange?.year + "-" + DateToChange?.month + "-" + DateToChange?.day;
  return formatedDate;
};
